import axios from "axios";

// Deliberately NOT using the shared apiClient from API.js - that instance is
// base-urled at our own Laravel API and attaches our own auth header, both of
// which would be wrong (and would leak an internal header) for a call that
// must go straight to Intuit and never touch our server.
const QB_PAYMENTS_BASE_URL =
  process.env.VUE_APP_QB_ENV === "production"
    ? "https://api.intuit.com/quickbooks/v4/payments/"
    : "https://sandbox.api.intuit.com/quickbooks/v4/payments/";

export default {
  tokenizeCard(card) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${QB_PAYMENTS_BASE_URL}tokens`, {
          card: {
            name: card.name,
            number: card.number,
            expMonth: card.expMonth,
            expYear: card.expYear,
            cvc: card.cvc,
            address: {
              streetAddress: card.address.streetAddress,
              city: card.address.city,
              region: card.address.region,
              postalCode: card.address.postalCode,
              country: "US",
            },
          },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
